import React from 'react'

class NotFoundPage extends React.Component {
  componentDidMount () {
    if (this.props && this.props.customDonationUrl && window) {
      window.location.href = this.props.customDonationUrl
    }
  }

  render () {
    return (
      <div className='notFound'>
        <div className='wrapper container'>
          <h1>Page Not Found</h1>
          <p>Sorry, the page you were trying to view does not exist.</p>
        </div>
      </div>
    )
  }
}

export default (NotFoundPage)
